import moment from "moment";
import { useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Typography,
  makeStyles
} from "@material-ui/core";
import { useGetSaHlrDataLazyQuery } from "@bonliva-crm/graphql";
import locale, { dateFormat } from "@bonliva-crm/locale";
import { ErrorCard } from "@common";

type Props = {
  open: boolean;
  consultantId: string;
};

const checkNames = ["S-HLR Barn", "S-HLR Vuxen", "A-HLR Barn", "A-HLR Vuxen"];

export function SaHlrModal(props: Props) {
  const classes = useStyles();

  const [load, { data, error }] = useGetSaHlrDataLazyQuery({
    fetchPolicy: "cache-and-network"
  });

  useEffect(() => {
    if (props.open) {
      load({
        variables: {
          consultantId: props.consultantId
        }
      });
    }
  }, [load, props.open, props.consultantId]);

  if (error) {
    return (
      <Card style={{ padding: 0 }}>
        <ErrorCard title="Cannot load data" message={error.message} />
      </Card>
    );
  }

  if (!data?.consultantById) {
    return (
      <Card style={{ padding: 0, minWidth: "30rem", minHeight: "10rem" }}>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="absolute"
          width="100%"
          height="100%"
        >
          <CircularProgress />
        </Box>
      </Card>
    );
  }

  const qualityChecks = (data.consultantById.qualityChecks || []).filter(
    (x) => x.country === "Sweden" && checkNames.includes(x.itemName)
  );

  return (
    <Card style={{ padding: 0, minWidth: "20rem" }}>
      <CardContent>
        {qualityChecks.length === 0 && (
          <Typography variant="body2">{locale.Empty}</Typography>
        )}

        {qualityChecks.map((x) => {
          const setOn = x.setDate ? moment(x.setDate).format(dateFormat) : "";
          const expiresOn = x.expirationDate
            ? moment(x.expirationDate).format(dateFormat)
            : "";

          return (
            <Box key={x.itemName} className={classes.qualityItemRoot}>
              <Box display="flex" justifyContent="space-between">
                <Typography variant="body2" style={{ fontWeight: 500 }}>
                  {x.itemName}
                </Typography>

                <Typography variant="body2" style={{ fontWeight: 500 }} noWrap>
                  {x.status ? locale.qualityStatuses[x.status] || x.status : "--"}
                </Typography>
              </Box>

              {setOn && (
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="caption" noWrap>
                    {locale.Date}
                  </Typography>

                  <Typography variant="caption" noWrap>
                    {setOn}
                  </Typography>
                </Box>
              )}

              {expiresOn && (
                <Box display="flex" justifyContent="space-between">
                  <Typography variant="caption" noWrap>
                    {locale.Expires}
                  </Typography>

                  <Typography variant="caption" noWrap>
                    {expiresOn}
                  </Typography>
                </Box>
              )}
            </Box>
          );
        })}
      </CardContent>
    </Card>
  );
}

const useStyles = makeStyles({
  qualityItemRoot: {
    "&:not(:first-child)": {
      marginTop: 8
    }
  }
});
